import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AppProvider, useApp } from "./store";
import { initInstall } from "./install";
import "./styles.css";

initInstall(); /* catch the browser's "can be installed" signal early – it may arrive before the first screen is drawn */

function Toasts() {
  const { toasts, dismiss } = useApp();
  return (
    <div className="toasts" aria-live="polite" role="status">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.kind}`} onClick={() => dismiss(t.id)}>
          {t.text}
        </div>
      ))}
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <AppProvider>
    <App />
    <Toasts />
  </AppProvider>,
);

if ("serviceWorker" in navigator && location.protocol !== "file:") {
  navigator.serviceWorker.register("/sw.js").catch(() => {
    /* offline shell is optional */
  });
}
